export default __webpack_public_path__ + "static/media/loan pools 2.82b6e375.svg";